import './ColorDetails.css';
import { connect } from 'react-redux';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { ellipsis } from '../../../helpers/formatter';
import * as Consts from '../../../constants';


const ColorDetails = ({ data, filterByPercentage = true }) => {
  let max = 0;

  const showLabel = data.length <= 3;
  let ColorDetailsData = data.map((category) => {
    const detailsCategory = category;
    detailsCategory.sum = category.values.reduce((accumulator, value) => ({
      y: accumulator.y + value.y,
    })).y;
    if (category.sum > max) max = category.sum;
    return category;
  });
  if (filterByPercentage) {
    ColorDetailsData = ColorDetailsData.filter(e => e.sum > max * Consts.PERCENTAGE_TO_HIDE)
      .sort((a, b) => (a.sum < b.sum ? 1 : -1));
  }

  return (
    <div className="ColorDetails">
      {
        ColorDetailsData.map(({ color, label }) => (
          <div key={label}
            className="legend"
          >
            <div data-for={`label_${label}`}
              data-tip={label}
              className="color"
              style={{
                backgroundColor: color,
              }}
            />
            <span className="label" data-for={`label_${label}`}
              data-tip={label}
            >
              {showLabel ? label : ellipsis(label)}

            </span>
            <ReactTooltip id={`label_${label}`}
              place="top"
              type="dark"
              effect="float"
              offset={{
                left: 0,
                top: -10,
              }}
              className="tooltip"
              html
              border={false}
            />
          </div>
        ))
      }

    </div>
  );
};

export default connect()(ColorDetails);
